import { render, staticRenderFns } from "./FileDownloadComponent.vue?vue&type=template&id=d44e5ee0&scoped=true&"
import script from "./FileDownloadComponent.vue?vue&type=script&lang=js&"
export * from "./FileDownloadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44e5ee0",
  null
  
)

export default component.exports